module.exports = __webpack_public_path__ + "media/images/success-e4fcd4fb9f2c82bb3e3560a65cd8f623.svg";